// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-B4n0E";
var _4 = "scrollBody-gCI1u";
var _5 = "header-2_B-y";
var _6 = "content-1FlNY";
var _7 = "scrollPaper-2WiGp";
var _8 = "footer-35uJA";
var _9 = "top_wrapper-IvVKB";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "scrollBody", _5 as "header", _6 as "content", _7 as "scrollPaper", _8 as "footer", _9 as "top_wrapper" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "scrollBody": _4, "header": _5, "content": _6, "scrollPaper": _7, "footer": _8, "top_wrapper": _9 }
